var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"100vh"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('loader',{staticStyle:{"z-index":"1000"}}):_vm._e()],1),_vm._v(" "),_c('router-view',{staticStyle:{"min-height":"100vh"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0cebd7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = jpFl
// module chunks = 1